import { BaseComponentRegistry } from "@/Common/Modularity/BaseComponentRegistry";
import { createRegistryListView } from "@/Common/Modularity/Components/ComponentRegistryWrapper";

enum AssignedDocumentsMenuItemsComponentId {
    OntarioMdHealthReportManager_MenuItem = 0
}

interface IAssignedDocumentsMenuItemsRegistryProps {
    selectedView: string;
    navigateToExtension: (extensionId: string) => void;
}

class AssignedDocumentsMenuItemsRegistry extends BaseComponentRegistry<AssignedDocumentsMenuItemsComponentId, IAssignedDocumentsMenuItemsRegistryProps> {}

const AssignedDocumentsMenuItemsRegistryView = createRegistryListView(() => AssignedDocumentsMenuItemsRegistry.getInstance());

export { AssignedDocumentsMenuItemsComponentId, AssignedDocumentsMenuItemsRegistry, AssignedDocumentsMenuItemsRegistryView, IAssignedDocumentsMenuItemsRegistryProps };
